import { useLiveQuery } from "dexie-react-hooks";
import { dueBills } from "@/lib/bills";
import { type Bill, db } from "@/lib/db";

// Live bill views over Dexie; they update as soon as a write or a pull lands.

/** Every live bill, unarchived first, then by next due date. */
export function useBills(): Bill[] | undefined {
	return useLiveQuery(async () => {
		const bills = await db.bills.filter((b) => !b.deleted_at).toArray();
		return bills.sort(
			(a, b) =>
				Number(a.archived) - Number(b.archived) ||
				a.next_due.localeCompare(b.next_due) ||
				a.name.localeCompare(b.name),
		);
	}, []);
}

/** Bills due on or before `day` (YYYY-MM-DD), oldest first. */
export function useDueBills(day: string): Bill[] | undefined {
	return useLiveQuery(
		async () => dueBills(await db.bills.where("next_due").belowOrEqual(day).toArray(), day),
		[day],
	);
}
